module.exports = "pegasus/assets/email1-view-online-icon.png";